(function( $ ) {
  
  var url = 'https://www.bauhausfurniture.biz/';

  var $SELECTED;
  var $OPTIONS;
  var $BUTTON;
  var $FORM;



  // Add icon for rolling
  function addIcon( container ) {
    $( '<span />', {
      class: 'icon icon-plus',
      style: 'display:none',
      html: window.b2hIcons.plus
    } ).prependTo( container );

    $( '<span />', {
      class: 'icon icon-minus',
      style: 'display:block',
      html: window.b2hIcons.minus
    } ).prependTo( container );
  }

  // Create placeholder for each option in #b2h-options-selected
  function createPlaceholderForSelectedOptions() {
    $.each( $.shopify.productOptions, function( index, productOption ) {
      var optionName = $.b2h.encodeOption(productOption.optionName);

      if (productOption.choiceName === '?') {
        className = 'selected-dropdown';
      }
      else {
        className = 'selected-swatch';
      }

      $selectedContainer = $( '<div />', {
        class: 'grid__item'
      } ).append( $( '<div/>', {
        id: 'selected-option-' + optionName,
        class: className
      } ) ).append( $( '<div/>', {
        id: 'selected-option-' + optionName + '-label',
        class: className + '-label'
      } ) );

      $selectedContainer.appendTo('#b2h-options-selected-swatches');

    } );
  }

  function createHTML( data ) {
    $.each( $.shopify.productOptions, function( index, productOption ) {
      var optionName = $.b2h.encodeOption( productOption.optionName );

      // Option information
      var htmlOption = $('<div />', {
        class: 'option',
        attr: {
          'data-option': optionName
        }
      });

      var htmlTitle = $( '<div />', {
        class: 'title toggleable',
        html: $.b2h.formatOptionName( productOption.optionName )
      } ).appendTo( htmlOption );
      
      addIcon( htmlTitle );
      
      $( htmlOption ).appendTo( '#b2h-available-options' );

      // Move existing Shopify radio selector to our available option container
      if ( productOption.choiceName === '?' ) {
        var dropdownID = '#productSelect-option-' + index;

        // OLD size selector code — prepended a blank <option> to force no selection
        // $( dropdownID )
        //     .attr( 'data-option', optionName )
        //     .prepend( $( '<option/>', {
        //       selected: 'selected',
        //       value: $( dropdownID + ' option:first' ).val()
        //     } ) )
        //     .parent()
        //     .detach()
        //     .appendTo( htmlOption );
        // END old size selector code

        // NEW radio selector code — no prepend needed, radios start unchecked
        $( dropdownID )
            .attr( 'data-option', optionName )
            .parent()
            .detach()
            .appendTo( htmlOption );
        // END new radio selector code

        return;
      }

      // Tiers
      var htmlTiers = $( '<div />', {
        class: 'tiers',
        style: 'display:non'
      } );
      
      for ( tier in data[ productOption.choiceName ] ) {

        // An option may be made up of multiple choices.
        // A choice may have tiers that are not available for the product.
        // Thus we have to check for these two things for each tier.
        var swatchGroups = {}
        var choices = productOption.choiceSelection.split( '&' );
        for ( var i = 0; i < choices.length; i++ ) {
          var choice = choices[i];

          var swatchGroupsInChoice = data[ productOption.choiceName ][ tier ][ choice ];
          if ( swatchGroupsInChoice ) {
            $.extend(swatchGroups, swatchGroupsInChoice);
          }
        }

        if ( $.isEmptyObject( swatchGroups ) ) {
          continue;
        }

        var optionIndex = $.shopify.optionIndices[ optionName ];
        var difference = $.b2h.getVariantPricingDifference( optionIndex, tier );

        // Check if tier is a valid product variation
        if ( false === difference ) {
          continue;
        }

        var additional_string = ( difference > 0 ) ? ' (add $' + difference + ')' : '';

        // Tier's information
        var htmlTier = $( '<div />', {
          class: 'tier',
          attr: {
            'data-tier': tier
          }
        } );

        var htmlTierInfo = $( '<div />', {
          class: 'tier-info toggleable grid grid--full'
        } );

        var htmlTierNum = $( '<p />', {
          class: 'tier-num grid__item',
          html: '<span>Option ' + tier + additional_string + '</span>'
        } ).appendTo( htmlTierInfo );

        addIcon( htmlTierNum );

        $( '<div>', {
          class: 'tier-swatch-selected grid__item one-fifth'
        } ).appendTo( htmlTierInfo );

        $( htmlTierInfo ).appendTo( htmlTier );

        var htmlTierSwatches = $( '<div />', {
          class: 'tier-swatches',
          style: 'display:non'
        } );
        
        for ( swatchGroup in swatchGroups ) {
          // Swatches in the swatch group
          var htmlFiles = $( '<div />', {
            // class: 'files grid grid--full'
            class: 'files grid--full',
            style: 'display:non'
          } );

          $.each( swatchGroups[ swatchGroup ]['files'], function( i, file ) {
            var htmlFile = $( '<div />', {
              class: 'file grid__item one-sixth'
            } );

            fileURL = url + file;
            swatchName = $.b2h.formatOptionName( $.b2h.getSwatchName( fileURL ) );

            var imgEl = new Image();
            imgEl.className = 'swatch-option';
            imgEl.alt       = 'Swatch image for ' + swatchName;
            imgEl.title     = swatchName;
            imgEl.setAttribute( 'data-src', fileURL );
            attachRetryHandler( imgEl, fileURL );
            imgEl.src = fileURL;

            htmlFile[0].appendChild( imgEl );
            $( htmlFile ).appendTo( htmlFiles );
          } );
          
          var htmlSwatchGroup = $( '<div />', {
            class: 'swatch-group-header grid grid--full',
            attr: {
              'data-swatch-group': swatchGroup
            }
          } );

          var htmlSwatchGroupInfo = $( '<div />', {
            class: 'swatch-group-info grid__item'
          } );

          htmlSwatchGroupInfo.html( $( '<p />', {
            class: 'swatch-group-name',
            html: swatchGroup
          } ) );

          if ( swatchGroups[ swatchGroup ]['specs'] ) {
            $( '<p />', {
              class: 'swatch-group-specs',
              html: swatchGroups[ swatchGroup ]['specs']
            } ).appendTo( htmlSwatchGroupInfo );
          }

          htmlSwatchGroup.addClass( 'toggleable' );
          addIcon( htmlSwatchGroupInfo );

          htmlSwatchGroupInfo.appendTo( htmlSwatchGroup );

          $( '<div>', {
            class: 'swatch-group-selected grid__item one-fifth'
          } ).appendTo( htmlSwatchGroup );

          htmlSwatchGroup.appendTo( htmlTierSwatches );

          $( htmlFiles ).appendTo( htmlTierSwatches );
        } // for swatchGroup

        $( htmlTierSwatches ).appendTo( htmlTier );
        $( htmlTier ).appendTo( htmlTiers );
  
      } // for tier

     $( htmlTiers ).appendTo( htmlOption );

    } );
  }

  // ---------------------------------------------------------------------------
  // Image reliability helpers
  // ---------------------------------------------------------------------------

  var MAX_RETRIES    = 5;
  var RETRY_BASE_DELAY = 1500; // ms — doubles on each retry: 1.5s, 3s, 6s, 12s, 24s

  /**
   * Attaches onerror / onload handlers to an <img> that retry the load
   * with exponential back-off on failure.
   *
   * @param {HTMLImageElement} imgEl
   * @param {string}           src     – canonical URL (no cache-buster)
   * @param {number}           [attempt=0]
   */
  function attachRetryHandler( imgEl, src, attempt ) {
    attempt = attempt || 0;

    imgEl.onerror = function() {
      imgEl.onerror = null;
      imgEl.onload  = null;
      if ( attempt < MAX_RETRIES ) {
        var delay = RETRY_BASE_DELAY * Math.pow( 2, attempt );
        setTimeout( function() {
          attachRetryHandler( imgEl, src, attempt + 1 );
          imgEl.src = src + '?r=' + ( attempt + 1 ); // cache-buster forces fresh request
        }, delay );
      } else {
        imgEl.classList.add( 'swatch-load-failed' );
        console.warn( '[b2h] Swatch image failed after ' + MAX_RETRIES + ' retries:', src );
      }
    };

    imgEl.onload = function() {
      imgEl.onerror = null;
      imgEl.classList.remove( 'swatch-load-failed' );
    };
  }

  /**
   * Starts a periodic health-check that scans all .swatch-option images.
   * Any image that is not yet loaded (naturalWidth === 0) and is not already
   * mid-retry will have loadSwatchImageDeferred called on it again.
   *
   * @param {number} [intervalMs=8000]  – how often to run the check (default 8 s)
   * @param {number} [maxRounds=6]      – stop checking after this many rounds
   */
  function startSwatchImageHealthCheck( intervalMs, maxRounds ) {
    intervalMs = intervalMs || 8000;
    maxRounds  = maxRounds  || 6;
    var rounds = 0;

    var checkId = setInterval( function() {
      rounds++;

      var $pending = $( '.swatch-option' ).filter( function() {
        // naturalWidth === 0 means the image is not yet decoded
        return ( !this.complete || this.naturalWidth === 0 ) &&
               !this.classList.contains( 'swatch-load-failed' );
      } );

      if ( $pending.length === 0 || rounds >= maxRounds ) {
        clearInterval( checkId );
        return;
      }

      $pending.each( function() {
        var src = this.getAttribute( 'data-src' ) || this.src.split( '?r=' )[0];
        if ( src ) {
          loadSwatchImageDeferred( this, src );
        }
      } );
    }, intervalMs );

    return checkId; // return so caller can clearInterval if needed
  }

  $.b2h = {
    
    // Create the HTML for the swatches from the server
    getSwatches : function ( vendor, options ) {
      var data = {
        vendor: vendor,
        options: options
      };
      
      $.ajax({
          method: 'POST',
          dataType: 'json',
          url: url + 'scripts/options.php',
          data: data,
          success: function( data ) {
            createHTML( data );
            // Begin health-checking 2 s after HTML is built
            setTimeout( startSwatchImageHealthCheck, 2000 );
          }
      });
    },

    encodeOption : function encodeOption( option ) {
      return option.replace(/ /g, '_').toLowerCase();
    },

    formatOptionName : function decodeOption( option ) {
      return option.replace(/_|-/g, ' ');
    },

    getVariantPricingDifference : function ( index, value ) {
      var indices = $.shopify.baseVariant.slice(0);
      indices[ index ] = value;

      var strIndices = indices.join( '-' );
      if ( ! $.shopify.variantPrices[ strIndices ] ) {
        return false;
      }

      return $.shopify.variantPrices[ strIndices ].difference / 100;
    },

    getSwatchName : function ( swatch ) {
      var swatchName = swatch.split('/').pop().split('.')[0];
      return swatchName.charAt(0).toUpperCase() + swatchName.slice(1);
    }
    
  }

  var removeRequiredOption = function( option ) {
    $( '#b2h-required-customizations' ).find( '#required-option-' + option ).remove();
  }
  
  $( document ).on( 'productOptionsReady', function() {

    // Hide/Show customizations available
    $BUTTON.on( 'click', function() {
      $OPTIONS.toggle();
    } );

    // Hide/Show options, tiers, and swatch groups
    $OPTIONS.on( 'click', '.option .title, .tier-info, .swatch-group-header', function() {
      $( this ).next().toggle();
      $( this ).find( '.icon-plus' ).toggle();
      $( this ).find( '.icon-minus' ).toggle();
    } );

    // Update 'Your Selection' with selected swatches
    $OPTIONS.on( 'click', '.swatch-option', function() {
      var $selectedOption    = $( this ).parents( '.option' );
      var selectedOptionName = $selectedOption.attr( 'data-option' );
      var swatch             = $( this ).attr( 'src' );
      var swatchName         = $.b2h.formatOptionName( $.b2h.getSwatchName( swatch ) );

        // Add image to the selected options container
      $( '#selected-option-' + selectedOptionName )
        .html( $( '<img />', {
          src: $( this ).attr( 'src' )
        } ) ).show();
      $( '#selected-option-' + selectedOptionName + '-label' )
        .html( swatchName );
      $SELECTED.show();
      
      // Clear all tier-swatch-selected and swatch-group-selected in this option
      $selectedOption.find( '.tier-swatch-selected, .swatch-group-selected' ).html( '' );
      
      // Update tier-swatch-selected for this tier
      var $selectedTier = $( this ).parents( '.tier' );
      var selectedTierNum = $selectedTier.attr( 'data-tier' );
      $selectedTier.find( '.tier-swatch-selected' ).html(
        $( '<img />', {
          src: swatch
        } )
      );

      // Update swatch-group-selected for this swatch group
      var $selectedSwatchGroup = $( this ).parents( '.files' ).prev( '.swatch-group-header' );
      var selectedSwatchGroupName = $selectedSwatchGroup.attr( 'data-swatch-group' );
      $selectedSwatchGroup.find( '.swatch-group-selected' ).html(
        $( '<img />', {
          src: swatch
        } )
      );

      // Update the line_item with the selection
      $FORM.find( '#option-name-' + selectedOptionName )
        .val( 'Option ' + selectedTierNum + ' / ' + selectedSwatchGroupName + ' / ' + swatchName );

      removeRequiredOption( selectedOptionName );

      // Change the (hidden) dropdown value so prices can be updated as appropriate
      var dropdownID = '#productSelect-option-' + $.shopify.optionIndices[ selectedOptionName ];
      $( dropdownID ).val( selectedTierNum ).trigger( 'change' );
    } );

    // OLD size selector code — listened for 'change' on the select dropdown
    // $OPTIONS.on( 'change', '.single-option-selector', function() {
    //   var selectedOptionName = $( this ).attr( 'data-option' );
    //   var selectedOptionValue = $( this ).val();
    //   $FORM.find( '#option-name-' + selectedOptionName ).val( selectedOptionValue );
    //   removeRequiredOption( selectedOptionName );
    //   $( '#selected-option-' + selectedOptionName ).empty().append( $( '<span/>', {
    //     html: selectedOptionValue
    //   } ) );
    //   $SELECTED.show();
    // } );
    // END old size selector code

    // NEW radio selector code — listen for 'change' on radio inputs inside .single-option-selector
    $OPTIONS.on( 'change', '.single-option-selector .single-option-radio', function() {
      var $container = $( this ).closest( '.single-option-selector' );
      var selectedOptionName = $container.attr( 'data-option' );
      var selectedOptionValue = $( this ).val();

      // Update the line_item with the selection
      $FORM.find( '#option-name-' + selectedOptionName ).val( selectedOptionValue );

      removeRequiredOption( selectedOptionName );

      // Update 'Your Selection'
      $( '#selected-option-' + selectedOptionName ).empty().append( $( '<span/>', {
        html: selectedOptionValue
      } ) );
      $SELECTED.show();
    } );
    // END new radio selector code

  } );

  $( document ).on( 'shopifyReady', function() {
    $SELECTED = $( '#b2h-options-selected' );
    $OPTIONS = $( '#b2h-available-options' );
    $BUTTON = $( '#b2h-customize' );
    $FORM = $( 'form[data-type="add-to-cart-form"]' );

    if ( $.isEmptyObject( $.shopify.productOptions ) ) {
      $BUTTON.hide();
      $OPTIONS.addClass( 'no-content' );
      return;
    }

    createPlaceholderForSelectedOptions();

    $( document ).trigger( 'productOptionsReady' );
  } );

      
  //appends an "active" class to .finishconfigure and .finishconfigure-content when the "disabled" button is clicked

  //appends an "active" class to .finishconfigure and .finishconfigure-content when the "disabled" button is clicked
  $(document).on("click", ".catchclick", function(e) {
    if ($(this).find(".product-form__submit").is(":disabled") || $(this).find(".product-form__submit").hasClass("disabled") || $(this).find("shopify-accelerated-checkout").is("[disabled]")){
      e.preventDefault();
      $(".finishconfigure-overlay, .finishconfigure-content").addClass("active");
      $(".finishconfigure-overlay").show();
    }
  });


//removes the "active" class to .finishconfigure and .finishconfigure-content when the "Close" button is clicked 
  $(document).on("click", ".close", function(e) {
    e.preventDefault();
    $(".finishconfigure-overlay, .finishconfigure-content").removeClass("active");
    $(".finishconfigure-overlay").hide();
  });


})(jQuery);